import zip from "./zip.png";
import pdf from "./pdf.png";
import jpg from "./jpg.png";
import gif from "./gif.png";
import png from "./png.png";
import txt from "./txt.png";
import defaultFile from './default.png';
import badnumber from './badnumber.png';
import booked from './booked.png';
import callback from './callback.png';
import dynamic from './dynamic.png';
import formerclient from './formerclient.png';
import noaccess from './noaccess.png';
import noshow from './noshow.png';
import sold from './sold.png';
import notinterested from './notinterested.png';
import notsold from './notsold.png';
import odd from './odd.png';

export function getFileIcon(name) {
  const ext = name && name.length > 0 && name.split(".").reverse()[0] || "";
  switch (ext) {
    case "zip":
      return zip;
    case "jpg":
    case "jpeg":
      return jpg;
    case "pdf":
      return pdf;
    case "gif":
      return gif;
    case "png":
      return png;
    case "txt":
      return txt;
    default:
      return defaultFile;
  }
}

export function getOverlay(status) {
  switch (status) {
    case "formerclient":
      return formerclient;
    case "booked":
      return booked;
    case "sold":
      return sold;
    case "notsold":
      return notsold;
    case "badnumber":
      return badnumber;
    case "odd":
      return odd;
    case "callback":
      return callback;
    case "dfolder":
      return dynamic;
    case "noaccess":
      return noaccess;
    case "noshow":
      return noshow;
    case "pni":
      return notinterested;
    default:
      return null;
  }
}



// WEBPACK FOOTER //
// ./src/containers/Briefcase/entry/icons/FileIcon.js